/* Create Shades theme JS: calm motion only. Everything respects prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Scroll reveal (24px rise + fade, staggered by --d) */
  function reveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e, i) { if (!e.style.getPropertyValue('--d')) e.style.setProperty('--d', (i % 4) * 0.08 + 's'); io.observe(e); });
  }

  /* Hero illustration drifts a few px toward the cursor */
  function heroParallax() {
    var art = document.querySelector('[data-hero-art] img');
    if (!art || reduce || !fine) return;
    window.addEventListener('mousemove', function (e) {
      var x = (e.clientX / window.innerWidth - 0.5) * 12, y = (e.clientY / window.innerHeight - 0.5) * 12;
      art.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
    }, { passive: true });
  }

  /* Services index: hover/focus a row to open it and swap the photos */
  function services() {
    document.querySelectorAll('[data-svc-index]').forEach(function (root) {
      var rows = root.querySelectorAll('.svc-row');
      var sets = root.querySelectorAll('[data-svc-set]');
      function open(r) {
        var idx = Array.prototype.indexOf.call(rows, r);
        rows.forEach(function (x) { x.classList.toggle('is-open', x === r); });
        sets.forEach(function (st, i) { var on = i === idx; st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); var a = st.querySelector('.see-work'); if (a) a.setAttribute('tabindex', on ? '0' : '-1'); });
      }
      rows.forEach(function (r) { r.addEventListener('mouseenter', function () { open(r); }); r.addEventListener('focusin', function () { open(r); }); });
    });
  }

  /* Live studio clocks: Dubai, London, India, New York */
  function clocks() {
    var zones = document.querySelectorAll('[data-zone]');
    if (!zones.length) return;
    function tick() {
      zones.forEach(function (z) {
        var tz = z.getAttribute('data-zone');
        var d = new Date();
        var parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(d);
        var h = +parts.find(function (p) { return p.type === 'hour'; }).value % 24, m = +parts.find(function (p) { return p.type === 'minute'; }).value;
        var hh = z.querySelector('[data-h]'), mm = z.querySelector('[data-m]');
        if (hh) hh.style.transform = 'rotate(' + ((h % 12) * 30 + m * 0.5) + 'deg)';
        if (mm) mm.style.transform = 'rotate(' + (m * 6) + 'deg)';
        var t = z.querySelector('[data-time]');
        if (t) t.textContent = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit' }).format(d);
        var part = z.querySelector('[data-part]');
        if (part) part.textContent = h < 12 ? 'Morning' : h < 17 ? 'Afternoon' : 'Evening';
      });
    }
    tick(); setInterval(tick, 20000);
  }

  /* Mobile / tablet menu drawer */
  function drawer() {
    var d = document.getElementById('MenuDrawer');
    if (!d) return;
    function set(open) { d.setAttribute('aria-hidden', open ? 'false' : 'true'); document.body.style.overflow = open ? 'hidden' : ''; }
    document.querySelectorAll('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-close-menu]')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* Product gallery thumbs */
  function gallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-main]');
      g.querySelectorAll('[data-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          main.src = b.getAttribute('data-src'); main.srcset = '';
          g.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
        });
      });
    });
  }

  /* Cart quantity steppers */
  function qty() {
    document.querySelectorAll('[data-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(0, (+input.value || 1) + (b.hasAttribute('data-plus') ? 1 : -1));
          input.value = v; input.form && input.form.submit();
        });
      });
    });
  }

  /* Currency switcher: submits the Shopify localization form */
  function currency() {
    document.querySelectorAll('[data-currency] button').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = document.getElementById('CurrencyForm'); if (!f) return;
        f.querySelector('input[name="country_code"]').value = b.getAttribute('data-country'); f.submit();
      });
    });
  }

  /* First-order coupon pop-up: shown once, auto-applies via /discount/CODE */
  function coupon() {
    var pop = document.getElementById('CouponPopup');
    if (!pop) return;
    var KEY = 'cs_coupon_seen';
    try { if (localStorage.getItem(KEY)) return; } catch (e) {}
    var delay = (+pop.getAttribute('data-delay') || 0) * 1000;
    var form = pop.querySelector('form');
    function close() { pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true'); try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    setTimeout(function () { pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); var f = pop.querySelector('input'); f && f.focus({ preventScroll: true }); }, delay);
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-close-coupon]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        fetch(form.action, { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } }).catch(function () {}).finally(function () {
          pop.querySelector('[data-state="form"]').hidden = true;
          pop.querySelector('[data-state="done"]').hidden = false;
          try { localStorage.setItem(KEY, '1'); } catch (e) {}
          // store the code in the session so it applies automatically at checkout
          fetch('/discount/' + encodeURIComponent(pop.getAttribute('data-code')), { credentials: 'same-origin' }).catch(function () {});
        });
      });
    }
  }


  /* Cart drawer: add to cart without leaving the page, quantity, remove */
  function cartDrawer() {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return;
    var html = document.documentElement, lastFocus = null;
    function open() { lastFocus = document.activeElement; root.setAttribute('aria-hidden', 'false'); html.classList.add('cart-open'); var c = root.querySelector('.cdrawer__x'); c && c.focus({ preventScroll: true }); }
    function close() { root.setAttribute('aria-hidden', 'true'); html.classList.remove('cart-open'); lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true }); }
    function refresh() {
      return fetch('/?sections=cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]'), cur = root.querySelector('[data-cart-inner]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var n = (doc.querySelector('.cdrawer__head .small') || {}).textContent;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n ? parseInt(n, 10) : 0; });
      });
    }
    function add(id, qty) {
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    }
    function flash(btn, label) {
      if (!btn) return;
      if (btn.classList.contains('card__add')) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); return; }
      var orig = btn.innerHTML; btn.innerHTML = label; btn.disabled = true;
      setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1600);
    }
    window.csCart = { open: open, close: close, refresh: refresh, add: add };

    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-add-to-cart]');
      if (a) {
        e.preventDefault(); a.disabled = true;
        add(a.getAttribute('data-variant')).then(refresh).then(function () { a.disabled = false; flash(a, 'Added'); open(); }).catch(function () { a.disabled = false; window.location.href = '/cart'; });
        return;
      }
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      var q = e.target.closest('[data-cart-qty]');
      if (q) {
        q.disabled = true;
        fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: q.getAttribute('data-key'), quantity: +q.getAttribute('data-cart-qty') }) })
          .then(refresh).catch(function () { q.disabled = false; });
        return;
      }
      var bag = e.target.closest('a[href="' + (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart"], a[href="/cart"]');
      if (bag && !bag.closest('[data-cart-drawer]') && !/^\/cart\/?$/.test(location.pathname) && bag.getAttribute('aria-label') && !e.metaKey && !e.ctrlKey) { e.preventDefault(); refresh().then(open); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.getAttribute('aria-hidden') === 'false') close(); });

    // product page: Add to cart stays on the page; Buy it now goes to checkout
    var form = document.getElementById('ProductForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        var s = e.submitter || document.activeElement;
        var buyNow = s && s.name === 'checkout';
        e.preventDefault();
        var id = form.querySelector('[name=id]').value;
        if (s) s.disabled = true;
        add(id).then(function () {
          if (buyNow) { window.location.href = '/checkout'; return; }
          return refresh().then(function () { if (s) { s.disabled = false; flash(s, 'Added'); } open(); });
        }).catch(function () { if (s) s.disabled = false; form.submit(); });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    reveal(); heroParallax(); services(); clocks(); drawer(); gallery(); qty(); currency(); coupon(); cartDrawer();
  });
})();
